import { AxiosResponse } from 'axios'
import IUserApiResponse from 'src/system/content/api/IUserApiResponse'
import ILocalContentService from 'src/system/content/services/ILocalContentService'
import IRemoteContentService from 'src/system/content/services/IRemoteContentService'
import IUserService from 'src/system/content/services/IUserService'

export class UserService implements IUserService {
  constructor(private localContentService: ILocalContentService, private remoteContentService: IRemoteContentService) {
    //
  }

  async fetchAllUsers(): Promise<void> {
    const response: AxiosResponse<IUserApiResponse[]> = await this.remoteContentService.request('GET', '/api/users/all')

    const responseUsers = response.data.map((user) => ({
      id: user.id.toString(),
      name: user.name,
      email: user.email,
      roles: user.roles,
    }))

    const db = this.localContentService.getDatabase()

    const storedIds = (await db.users.find().exec()).map((user) => user.id)
    const responseIds = responseUsers.map((user) => user.id)

    const idsToDelete = storedIds.filter((id) => !responseIds.includes(id))

    await Promise.all([db.users.bulkRemove(idsToDelete), db.users.bulkUpsert(responseUsers)])
  }
}
